import { AxiosRequestConfig } from 'axios'
import { apiService } from '../../api-base'
import {
  ProductReviewsResponse,
  ProductReviewsStoresResponse,
  SetProductReviewStatusPayload,
} from './types'

export class ReviewsService {
  static getProductReviews(
    config?: AxiosRequestConfig,
  ): Promise<ProductReviewsResponse> {
    return apiService.get<ProductReviewsResponse>('/productReviews', config)
  }

  static getNotModeratedStores(): Promise<ProductReviewsStoresResponse> {
    return apiService.get<ProductReviewsStoresResponse>(
      '/productReviews/notModerated',
    )
  }

  static setProductReviewStatus(
    id: string,
    payload: SetProductReviewStatusPayload,
  ) {
    return apiService.put(`/productReviews/${id}/setStatus`, payload)
  }
}
